import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../../theme';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'space-between',
                width: '100%',
            },
        },
        textContent: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                alignItems: 'flex-start',
            },
        },
        img: {
            padding: theme.spacing(0.5),
            marginBottom: theme.spacing(0.5),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& > img': {
                maxWidth: '80%',
            },
            [theme.breakpoints.down('xs')]: {
                marginRight: 0,
                marginBottom: 0,
                padding: 0,
                '& > img': {
                    maxWidth: '5rem',
                },
            },
        },
        title: {
            fontWeight: 900,
            marginBottom: theme.spacing(0.5),
            marginTop: theme.spacing(1),
        },
        paragraph: {
            marginBottom: 0,
            textAlign: 'center',
            [theme.breakpoints.down('xs')]: {
                textAlign: 'left',
            },
            fontWeight: 900,
            borderTop: `1px solid ${brandColors.tableBorder}`,
            paddingTop: theme.spacing(1),
            marginTop: theme.spacing(1),
        },
    };
};
